import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { bootstrapApplication } from '@angular/platform-browser';
import { ENVIRONMENT, environment } from 'environments';
import { MESSAGING_CONFIG, MessagingStore } from '@messaging';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withDebugTracing, UrlHandlingStrategy } from '@angular/router';
import { HybridUrlHandlingStrategy } from '../../../libs/shims/src/lib/shims/routing/hybrid-url-handling.strategy';
import { UpgradeModule } from '@angular/upgrade/static';
import { ServiceUpgradeInjectorService } from '@shims';
import {
  authServiceProvider,
  constantsServiceProvider,
  loadUpgradedServices,
  loggerServiceProvider,
  mediaServiceProvider,
  notificationServiceProvider,
  ordersServiceProvider,
  photoServiceProvider,
  pollingServiceProvider,
  usersServiceProvider,
  utilsServiceProvider,
} from '../angularJs/src/app/ajs-upgraded-providers';
import '../angularJs/src/app/index';
import '../angularJs/src/app/index.module.ajs';
import { routes } from '../src/app/app.routes';
import { loadDowngradedComponents } from '../src/app/downgraded-component';
import { loadDowngradedServices } from '../src/app/downgraded-services';
import { AppComponent } from './app/app.component';
import { loadConstantsIntoAngularJS } from './app/app.module';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { UpgradeAppModule } from './app/upgrade.module';

import { AwsRum, AwsRumConfig } from 'aws-rum-web';

if (FEATURE_BODACDC_XXXX) {
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      endpoint: 'https://dataplane.rum.eu-west-2.amazonaws.com',
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: true,
      signing: true, // If you have a public resource policy and wish to send unsigned requests please set this to false
    };

    const APPLICATION_ID = '46f67109-948d-4771-a17d-a5b11082f116';
    const APPLICATION_VERSION = '1.0.0';
    const APPLICATION_REGION = 'eu-west-2';

    const awsRum: AwsRum = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    { provide: ENVIRONMENT, useValue: environment },
    {
      provide: MESSAGING_CONFIG,
      useValue: { baseUrl: (environment.constants as { ADMIN_API_URL: string }).ADMIN_API_URL },
    },
    { provide: UpgradeAppModule, useClass: UpgradeAppModule },
    importProvidersFrom(UpgradeModule),
    provideAnimations(),
    mediaServiceProvider,
    constantsServiceProvider,
    notificationServiceProvider,
    pollingServiceProvider,
    ordersServiceProvider,
    loggerServiceProvider,
    utilsServiceProvider,
    authServiceProvider,
    photoServiceProvider,
    usersServiceProvider,
    ServiceUpgradeInjectorService,
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    provideRouter(routes, withComponentInputBinding(), withDebugTracing()),
    { provide: UrlHandlingStrategy, useClass: HybridUrlHandlingStrategy },
    MessagingStore,
  ],
})
  .then(ref => {
    // Eagerly instantiate MessagingStore so withEventHandlers is subscribed
    // before the AngularJS visit controller calls VisitBridgeStore.setActivePatient()
    ref.injector.get(MessagingStore);
    loadConstantsIntoAngularJS();
    loadDowngradedComponents();
    loadDowngradedServices();
    loadUpgradedServices();
    // Initializes the upgrade module
    const upgrade = ref.injector.get(UpgradeAppModule);
    upgrade.ngDoBootstrap();
  })
  .catch(err => console.error(err));
